export const ACCESS_ALERT_TEXT =
  'Esta característica solo está disponible en planes superiores';
